import React from 'react';
import Dialog from '#lib/components/dialog.jsx';
import Button from '#lib/components/button.jsx';

export default function RedirectModal(props) {
    const { isShown, onClose } = props;

    const handleRedirect = () => {
        location.pathname = 'settings/billing';
    };

    return (
        <Dialog isOpen={isShown} onClose={onClose} className="h-screen flex items-center justify-center fixed inset-4">
            <Dialog.Panel className="flex flex-col gap-4">
                <div className="pr-8">
                    <Dialog.CloseButton />
                    <div className="flex flex-col gap-2">
                        <p className="font-semibold text-lg"> {_t.connections.noBillingInfo()} </p>
                        <p> {_t.connections.fillBillingInfo()} </p>
                    </div>
                </div>
                <div className="flex justify-end">
                    <Button onClick={handleRedirect}>{_t.connections.goToBilling()}</Button>
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
